import { render, staticRenderFns } from "./MintAgreementDetailDialog.vue?vue&type=template&id=315776b9"
import script from "./MintAgreementDetailDialog.vue?vue&type=script&lang=js"
export * from "./MintAgreementDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports